import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCard,[_c('div',{staticStyle:{"width":"100%","position":"relative"}},[_c(VBtn,{staticStyle:{"position":"absolute","right":"20px","top":"15px"},attrs:{"icon":""},on:{"click":_vm.closeModal}},[_c(VIcon,{attrs:{"size":"30"}},[_vm._v(" "+_vm._s(_vm.icons.mdiClose)+" ")])],1)],1),_c('div',{staticClass:"py-14  px-4"},[_c(VImg,{staticStyle:{"border-radius":"5px"},attrs:{"src":_vm.image}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }